import { W3CTraceContextPropagator } from "@opentelemetry/core";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { FetchInstrumentation } from "@opentelemetry/instrumentation-fetch";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import type * as Sentry from "@sentry/nextjs";
import { isSentryEnabled } from "@remi/sentry";

import { initSentryNextjs } from "./sentry/initSentryNextjs";

interface NextjsClientObservabilityOptions {
  sentry?: Sentry.NodeOptions;
}

export function initObservabilityNextjsClient(options?: NextjsClientObservabilityOptions): void {
  if (isSentryEnabled()) {
    initSentryNextjs(options?.sentry);
  }

  const provider = new WebTracerProvider();
  provider.register({
    propagator: new W3CTraceContextPropagator(),
  });

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: [/^\//, new RegExp(`^${window.location.origin}`)],
      }),
    ],
  });
}
